import VendorIntegrationService from "@/services/api/vendorIntegration";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const name = "vendorIntegration";

const initialState = {
  totalVendorIntegrations: 0,
  vendorIntegrations: [],
  isFetching: false,
};

export const getVendorIntegrations = createAsyncThunk(
  `${name}/getVendorIntegrations`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await VendorIntegrationService.getVendorIntegrations(
        params
      );
      return data.data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const vendorIntegrationSlice = createSlice({
  name,
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVendorIntegrations.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getVendorIntegrations.fulfilled, (state, action) => {
        state.isFetching = false;
        state.vendorIntegrations = action.payload.rows;
        state.totalVendorIntegrations = action.payload.count;
      })
      .addCase(getVendorIntegrations.rejected, (state, action) => {
        state.isFetching = false;
        console.error("Failed to fetch vendor integrations:", action.payload);
      });
  },
});

export default vendorIntegrationSlice.reducer;
export const { clear } = vendorIntegrationSlice.actions;
